<template>
  <div class="contact-card w-full rounded-card border border-solid border-line bg-surface p-6 text-center shadow-sm">
    <div
      :style="{ backgroundImage: `url(${contact.image.cropped})` }"
      class="mx-auto mb-4 h-[100px] w-[100px] rounded-full border border-solid border-line bg-transparent bg-cover bg-center bg-no-repeat"
    />
    <div class="font-display text-base font-semibold text-ink">
      {{ contact.name }}
    </div>
    <div class="min-h-[1.44em] text-sm text-muted">
      {{ contact.job_description }}
    </div>

    <div class="my-4 h-px bg-line" />

    <div class="text-left">
      <div class="mb-2 font-display text-xs font-bold uppercase tracking-wider text-muted-faint">
        Contact
      </div>
      <div class="text-sm">
        <div
          v-if="contact.email"
          class="contact-card__contact-email flex items-center gap-2 leading-[1.8]"
        >
          <i class="hf hf-fw hf-lg hf-envelope shrink-0 text-brand" />
          <a
            :href="'mailto:' + contact.email"
            :title="contact.email"
            class="min-w-0 truncate text-ink hover:text-accent"
          >
            {{ contact.email }}
          </a>
        </div>
        <div
          v-if="contact.phone"
          class="contact-card__contact-phone flex items-center gap-2 leading-[1.8]"
        >
          <i class="hf hf-fw hf-lg hf-phone shrink-0 text-brand" />
          <a
            :href="'mailto:' + contact.phone"
            :title="contact.phone"
            class="min-w-0 truncate text-ink hover:text-accent"
          >
            {{ contact.phone }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true
    }
  }
}
</script>
